// extracted by mini-css-extract-plugin
export default {"productDescription":"r_-z","featuredDescription":"s_-z","description":"t_-z","more":"u_-z","descriptionSku":"v_-z"};